import { FormStage } from '@genericBookings/types/FormStage';
export default [
    {
        step: FormStage.Date,
        isComplete: false,
        isViewed: false,
        isInitialised: false,
    },
    {
        step: FormStage.Attendees,
        isComplete: false,
        isViewed: false,
        isInitialised: false,
    },
    {
        step: FormStage.Session,
        isComplete: false,
        isViewed: false,
        isInitialised: false,
    },
];
